import React from 'react';

import NewDPE from '../../components/Prospecting/NewDPE';


function NewDPEView() {
  return (
    <NewDPE />
  );
}

export default NewDPEView;
